import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  defaultTheme = 'compact-default';
  cookieKey = 'themeswitcher:theme';

  constructor(private readonly cookieService: CookieService) { }

  public get theme(): string {
    return this.cookieService.get(this.cookieKey);
  }

  isDefaultTheme(): boolean {
    return this.theme === this.defaultTheme;
  }

  theme$ = new BehaviorSubject<string>(this.theme);

  saveTheme(theme: string): void {
    this.cookieService.set(this.cookieKey, theme);
  }

  /**
   * We will have only one theme going forward: 'compact-default'
   */
  ensureDefaultTheme(): void {
    const isDefault = this.isDefaultTheme();

    if (isDefault) {
      return;
    }

    // eslint-disable-next-line no-console
    console.info(`Current Theme: ${this.theme}, Saving Theme: ${this.defaultTheme}`)

    this.saveTheme(this.defaultTheme);
  }
}
